export default "__VITE_ASSET__ba1fea15__"